import { Link } from "react-router-dom";
import { fmtDate, fullName } from "@/lib/format";
import { L } from "@/i18n";
import { StatusBadge } from "@/components/dashboard/StatusBadge";
import { PlanBadge } from "./PlanBadge";
import { UserActions } from "./UserActions";
import { LastSeenCell, UsageCell } from "./UsageCells";
import { SortHeader } from "./SortHeader";

const TH = "px-4 py-3 text-left font-mono text-[10px] uppercase tracking-[0.15em] text-slate-500 font-medium whitespace-nowrap";
const COLS = [["Name", "Nome"], ["Username", "Utilizador"], ["Email", "Email"], ["Role", "Perfil"], ["Plan", "Plano"], ["Status", "Estado"], ["Last opened", "Última abertura", "last_seen"], ["Usage 30d", "Uso 30d", "usage"], ["Registered", "Registo", "created"], ["", ""]];

export const UsersTable = ({ users, currentUserId, onRequest, sort, onSort }) => (
  <div className="overflow-x-auto">
    <table className="w-full min-w-[1100px] text-sm" data-testid="users-table">
      <thead className="border-b border-[#1e293b] bg-[#0f172a]/60">
        <tr>{COLS.map(([en, pt, key], i) => (key
          ? <SortHeader key={i} label={en} pt={pt} sortKey={key} sort={sort} onSort={onSort} className={TH} />
          : <th key={i} className={TH}>{L(en, pt)}</th>))}</tr>
      </thead>
      <tbody>
        {users.map((u) => (
          <tr key={u.id} className="border-b border-[#1e293b]/70 last:border-0 hover:bg-slate-800/30 transition-colors" data-testid={`user-row-${u.id}`}>
            <td className="px-4 py-3">
              <Link to={`/users/${u.id}`} className="text-slate-200 hover:text-amber-400 transition-colors" data-testid={`user-name-link-${u.id}`}>
                {fullName(u)}
              </Link>
            </td>
            <td className="px-4 py-3 font-mono text-xs text-slate-400">{u.username}</td>
            <td className="px-4 py-3 text-slate-400 truncate max-w-[240px]">{u.email}</td>
            <td className="px-4 py-3 font-mono text-[11px] uppercase text-slate-400">
              {u.role === "admin" ? <span className="text-amber-500">admin</span> : u.role}
            </td>
            <td className="px-4 py-3" data-testid={`user-plan-${u.id}`}><PlanBadge user={u} /></td>
            <td className="px-4 py-3" data-testid={`user-status-${u.id}`}><StatusBadge status={u.status} /></td>
            <td className="px-4 py-3" data-testid={`user-last-seen-${u.id}`}><LastSeenCell user={u} /></td>
            <td className="px-4 py-3" data-testid={`user-usage-${u.id}`}><UsageCell user={u} /></td>
            <td className="px-4 py-3 font-mono text-xs text-slate-400 whitespace-nowrap">{fmtDate(u.created_at)}</td>
            <td className="px-4 py-3 text-right">
              <UserActions user={u} isSelf={u.id === currentUserId} onRequest={onRequest} />
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);
